import getLinkSegments from './getLinkSegments';

export default function isLink(content: string) {
  const processedContent = content.trim();
  const segments = getLinkSegments(processedContent);
  const links = segments.filter((segment) => segment.isLink);
  const surroundingContent = segments
    .filter((segment) => !segment.isLink)
    .map((segment) => segment.content)
    .join('');
  const isContentLink =
    links.length === 1 && !/[\p{L}\p{N}\s]/u.test(surroundingContent);
  const link = isContentLink
    ? links[0]?.content || processedContent
    : processedContent;

  return {
    isContentLink,
    link,
  };
}
